module.exports = ".slider {\n    height:120px;\n    width:40px;\n    margin-left:auto;\n    margin-right:auto;\n    display:block;\n}\n\n.handle {\n    cursor:pointer;\n}\n\n.title {\n    font-family:'Arial';\n    font-size:0.75em;\n    margin-top:5px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/slider/slider.component.css
// module id = ./src/app/slider/slider.component.css
// module chunks = main